import * as React from 'react';

export const HourGlassIcon = () => {
  return (
    <svg
      width={72}
      height={72}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M69 41c0 15.464-12.536 28-28 28S13 56.464 13 41s12.536-28 28-28 28 12.536 28 28"
        fill="#F5F7F8"
      />
      <path
        d="M63 36C63 21.088 50.912 9 36 9S9 21.088 9 36s12.088 27 27 27 27-12.088 27-27m2 0c0 16.016-12.984 29-29 29S7 52.016 7 36 19.984 7 36 7s29 12.984 29 29"
        fill="#5C6975"
      />
      <path
        d="M27 47.502c0-2.494.848-4.915 2.406-6.862l3.313-4.14-3.313-4.14A11 11 0 0 1 27 25.498a1 1 0 0 1 2 0c0 2.04.695 4.02 1.969 5.612l3.47 4.336.084.119a1.7 1.7 0 0 1 0 1.87l-.085.119-3.47 4.336A9 9 0 0 0 29 47.502a1 1 0 0 1-2 0m16 0c0-1.913-.61-3.772-1.736-5.31l-.233-.302-3.47-4.336a1.7 1.7 0 0 1 0-2.108l3.47-4.336.233-.302A9 9 0 0 0 43 25.498a1 1 0 0 1 2 0c0 2.338-.746 4.611-2.123 6.491l-.283.371-3.314 4.14 3.314 4.14.283.37A11 11 0 0 1 45 47.503a1 1 0 0 1-2 0m-8.55-7.046a2 2 0 0 1 3.178.1l3.057 4.28.083.126C41.57 46.274 40.633 48 39.057 48h-6.114c-1.626 0-2.573-1.838-1.628-3.162l3.057-4.28zm2.953-7.633a2 2 0 0 1-2.965-.176l-3.22-4.023-.059-.083a1 1 0 0 1 1.554-1.243l.068.076L36 31.399l3.219-4.024a1 1 0 0 1 1.562 1.25l-3.22 4.023zM27 51a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2zm0-27a1 1 0 1 1 0-2h18a1 1 0 1 1 0 2z"
        fill="#5C6975"
      />
    </svg>
  );
};
